import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateField',
})
export class TranslateFieldPipe implements PipeTransform {
  transform(value: { [key: string]: string } | null | undefined, lang: string, fallback?: string): string {
    if (!value) {
      return fallback ?? '';
    }

    return value[lang] ?? fallback ?? '';
  }
}
